<template>
    <pc-table
        v-bind:items="eSignatures"
        v-bind:columns="columns"
        v-bind:initial-sort="initialSort"
        v-bind:empty-text="emptyTable"
        v-bind:hide-actions="!isAdminPage"
        key-prop="EnvelopeId"
        hide-search>
        <template v-slot:Date="eSignature">
            <div>
                <span
                    v-if="wideView && eSignature.IsInvisibleToProjectOwner"
                    class="text-primary fw-bold"
                    >*</span
                >
                <span>{{ eSignature.Date }}</span>
            </div>
        </template>
        <template v-slot:DocumentNames="eSignature">
            <div class="d-flex">
                <div
                    v-if="!wideView && eSignature.IsInvisibleToProjectOwner"
                    class="text-primary fw-bold me-1">
                    *
                </div>
                <div class="flex-grow-1">
                    <div
                        v-for="(doc, index) in eSignature.DocumentNames"
                        v-bind:key="'document' + index">
                        <div>{{ doc }}</div>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:Recipients="eSignature">
            <div
                v-for="(recipient, index) in eSignature.Recipients"
                v-bind:key="'recipient' + index">
                <recipient-display v-bind:recipient="recipient" />
            </div>
        </template>
        <template v-slot:Status="eSignature">
            <span v-bind:class="getStatusDisplayClass(eSignature)">
                {{ eSignature.Status.Display }}
            </span>
        </template>
        <template v-slot:actionsRow="eSignature">
            <e-signature-action-row
                v-bind:e-signature="eSignature"
                v-bind:resending="resending"
                v-bind:is-read-only-user="isReadOnlyUser"
                v-on:resend-notifications="resendNotifications(eSignature)"
                v-on:signature-updated="onSignatureUpdated(eSignature, $event)" />
        </template>
    </pc-table>
</template>
<script>
    import eSignatureActionRow from "./eSignatureActionRow.vue";
    import recipientDisplay from "./recipientDisplay.vue";
    import { mapI18n } from "Util/i18n";
    import { KEYS, NAMESPACE } from "./i18n/legacyESignatureCapsuleTable.i18n";

    export default {
        components: {
            eSignatureActionRow,
            recipientDisplay
        },
        props: {
            eSignatures: { type: Array, required: true },
            isAdminPage: { type: Boolean, required: true },
            wideView: { type: Boolean, required: true },
            isReadOnlyUser: { type: Boolean, required: true },
            initialSort: { type: Array, required: true }
        },
        emits: ["resend-notifications", "signature-update"],
        data() {
            return {
                resending: false
            };
        },
        computed: {
            controller() {
                return this.$serviceControllers.ESignatures;
            },
            columns() {
                return this.isAdminPage ? this.adminCols : this.cols;
            },
            adminCols() {
                return [
                    {
                        header: this.dateHeader,
                        property: "DateString",
                        orderable: true,
                        searchable: true,
                        visible: true
                    },
                    {
                        header: this.documentsHeader,
                        property: "DocumentNames",
                        orderable: true,
                        searchable: true,
                        visible: true,
                        isCardHeader: true,
                        sortValue(item) {
                            return item.DocumentNames.join(",");
                        }
                    },
                    {
                        header: this.signatoriesHeader,
                        property: "Recipients",
                        orderable: false,
                        searchable: false,
                        visible: false
                    },
                    {
                        header: this.statusHeader,
                        property: "Status",
                        orderable: true,
                        searchable: true,
                        visible: true
                    }
                ];
            },
            cols() {
                return [
                    {
                        header: this.dateHeader,
                        property: "DateString",
                        orderable: true,
                        searchable: true,
                        visible: true
                    },
                    {
                        header: this.documentsHeader,
                        property: "DocumentNames",
                        orderable: true,
                        searchable: true,
                        visible: true,
                        isCardHeader: true,
                        sortValue(item) {
                            return item.DocumentNames.join(",");
                        }
                    },
                    {
                        header: this.signatoriesHeader,
                        property: "Recipients",
                        orderable: true,
                        searchable: true,
                        visible: true,
                        sortValue(item) {
                            return item.Recipients.map((r) => r.SignatoryTag).join(",");
                        }
                    },
                    {
                        header: this.statusHeader,
                        property: "Status",
                        orderable: true,
                        searchable: true,
                        visible: true
                    }
                ];
            },
            emptyTable() {
                return this.emptyTabelText;
            },
            ...mapI18n(KEYS, NAMESPACE)
        },
        methods: {
            getStatusDisplayClass(eSignature) {
                return eSignature.Status.IsReady ? "text-bubble-success" : "text-bubble-danger";
            },
            resendNotifications(eSignature) {
                this.$emit("resend-notifications", eSignature);
            },
            onSignatureUpdated(eSignature, updatedESignature) {
                this.$emit("signature-update", eSignature, updatedESignature);
            }
        }
    };
</script>
